// import { useNavigate } from "react-router-dom";

// const Docs = ({ projectId, toggleMenu }) => {
//   const navigate = useNavigate();

//   const goToData = () => {
//     navigate(`/project/${projectId}/docs/data`);
//     // 다른 메뉴가 열려 있으면 닫기 (부모 컨벤션 유지)
//     if (typeof toggleMenu === "function") toggleMenu(null);
//   };

//   return (
//     <div className="menu-root text-white">
//       <span
//         type="button"
//         onClick={goToData}
//         className="menu-trigger cursor-pointer"
//       >
//         자료실
//       </span>
//     </div>
//   );
// };

// export default Docs;

import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function DocsMenu(props) {
  return (
    <Dropdown
      menuKey="docs"
      menu={projectMenus.docs}
      {...props}
    />
  );
}
